import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../services/auth.service';
import { version } from '../../../../package.json';
import { AuthResponse } from '../../models/auth-response';
import { SidebarService } from '../../services/sidebar.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainLayoutComponent implements OnInit {
  public opened = false;
  public user: AuthResponse;
  public version: string = version;
  private _isDetectionSidebarOpen: boolean;

  constructor(
    private authService: AuthService,
    private sidebarService: SidebarService
  ) {}

  ngOnInit() {
    this.authService.getUser().subscribe(user => (this.user = user));
    this.subscribeToDetectionSidebar();
  }

  public get isDetectionSidebarOpen(): boolean {
    return this._isDetectionSidebarOpen;
  }

  public set isDetectionSidebarOpen(value: boolean) {
    this.sidebarService.setDetectionSidebarOpen(value);
  }

  public get isDetectorUser(): boolean {
    return this.user
      ? this.user.profileName.toLowerCase() === 'detection'
      : false;
  }

  private subscribeToDetectionSidebar() {
    this.sidebarService.detectionSidebarOpen$.subscribe(isOpened => {
      this._isDetectionSidebarOpen = isOpened;
    });
  }
}
